import React, { useContext, useEffect, useState, useRef } from "react";
import { AudioHandler } from "../../Apihander/AudioRecording/AudioRecording";
import { doCreateFolder, doFindFolder } from "../../Apihander/Folder/Folder";
import SidebarContext from "../../contexts/MyContext";
import AudioFile from "../audio/audio";
import Folder from "../Folder";
import Modal from "../Modal/Modal";
import { errorToast, errorToastBottom, successToast } from "../../utils/notificationUtils";
import { doDeleteFolder, doRenameFolder } from "../../Apihander/Folder/Folder";
import PlayButton from "../../components/button/playButton"
import { Icon } from "@iconify/react";
import { ALL_ACTIONS_FILTER, AUDIO_ACTION_FILTERS } from "../../utils/audioActions";
import "../../css/app/recordingList.css";



const AudioList = ({ startRecording, elapsedTime }) => {
    const {
        selectMergeAudio,
        setSelectMergeAudio,
        clickedAudios,
        setClickedAudios,
        audioReName,
        setAudioReName,
        initialAudioName,
        setAudio,
        audio,
        folders,
        setFolders,
        openFolderCreateModal,
        setOpenFolderCreateModal,
        folderAudioData,
        setFolderAudioData,
        noFolderAudioData,
        setNoFolderAudioData,
        selectedSideBarFolderId,
        filterAudioData,
        favoriteAudio,
        setFavoriteAudio,
        setFilterAudioData,
        currentAudioId,
        setCurrentAudioId,
        tabIndex,
        setTabIndex,
        openDropdownId,
        setOpenDropdownId,
        selectedFolderAudioId,
        listTabIndex,
        setListTabIndex,
        isFilterDropdownOpen,
        setIsFilterDropdownOpen,
        recordNew,
        setRecordNew,
        setActionTabIndex,
        setSelectedFolderAudioId,
        isRecordingStarted, setIsRecordingStarted,
        showModal, setShowModal,
        modalMessage, setModalMessage,
        setAudioIndex,
        setAutoStartRecording,
        setRecordingFolderId

    } = useContext(SidebarContext);
    // const [listTabIndex, setListTabIndex] = useState(1);
    const [folderName, setFolderName] = useState("");
    const [load, setLoad] = useState(false);
    const [isDateAscending, setIsDateAscending] = useState(true);
    const [isNameAscending, setIsNameAscending] = useState(true);
    const [isSizeAscending, setIsSizeAscending] = useState(true);
    const [openRenameModal, setOpenRenameModal] = useState(false);
    const [openMoveToFolderModal, setOpenMoveToFolderModal] = useState(false);
    const [selectedFolderId, setSelectedFolderId] = useState('');
    const [isMoveToFolder, setIsMoveToFolder] = useState(false); // State to track action type
    const [isButtonDisabled, setIsButtonDisabled] = useState(true);
    const maxLength = 20; // Define the maximum length
    const maxLengthAudioRename = 100; // Define the maximum length

    const [collapsedIds, setCollapsedIds] = useState(new Set());
    const [isOpen, setIsOpen] = useState(false);
    const [openRenameFolder, setOpenRenameFolder] = useState(false)
    const [openRenameFolderId, setOpenRenameFolderId] = useState(null); // Store the folder ID instead of a boolean

    const [folderReName, setFolderReName] = useState('')
    const [initialFolderName, setInitialFolderName] = useState('')
    const [loading, setLoading] = useState(false);
    const [deleteFolderModal, setDeleteFolderModal] = useState(false)
    const [deleteDataId, setDeleteDataId] = useState()
    const [openFilterDropdown, setOpenFilterDropdown] = useState(false)
    const dropdownRef = useRef(null);
    const dropdownFilterRef = useRef(null); // Ref to store the dropdown element
    // View-only filter by recording.audio.lastActionPerformed; the stored lists are never changed.
    const [actionFilter, setActionFilter] = useState(ALL_ACTIONS_FILTER);
    const actionFilterRowRef = useRef(null);
    // Which edges of the chip row have more chips hidden past them.
    const [actionFilterOverflow, setActionFilterOverflow] = useState({ start: false, end: false });
    // const [isRecordingStarted, setIsRecordingStarted] = useState(false);




    const handleSave = async () => {
        // Handle Create functionality here
        setLoad(true)
        const trimmedFolderName = folderName.trim();

        try {
            const payload = {
                name: trimmedFolderName,
            };
            const data = await doCreateFolder(payload);
            if (data.status) {
                setFolders((prevFolders) => [data.data, ...prevFolders])
                setFolderName("");
                successToast(data.message);
                setOpenFolderCreateModal(false);
                setLoad(false)

            } else {
                const errorMessage =
                    data?.response?.data?.error || data?.response?.data?.message || data?.message || "An error occurred";
                console.log(errorMessage);
                errorToast(errorMessage);
                setLoad(false)

            }
        } catch (error) {
            console.log("Create Folder Error :", error);
            const errorMessage =
                error?.response?.data?.message || error?.message || "An error occurred";
            errorToast(errorMessage);
            setLoad(false)

        }
    };



    const handleSaveAndMove = async () => {
        setLoad(true)
        try {
            const payload = { name: folderName };
            const data = await doCreateFolder(payload);
            // console.log(data, 'create folder')
            if (data.status) {
                // Add new folder to the folders state
                setFolders((prevFolders) => [data.data, ...prevFolders]);
                setFolderName("");
                const movePayload = {
                    audioId: currentAudioId,
                    folderId: data?.data?._id
                }
                const moveResponse = await AudioHandler.doMoveToFolder(movePayload);

                if (moveResponse.statusCode == 200) {
                    // successToast('Audio moved to new folder successfully');
                    setFilterAudioData((prevAudios) =>
                        prevAudios.filter(audio => audio?._id !== currentAudioId)
                    );
                    setLoad(false)

                } else {
                    const moveErrorMessage =
                        moveResponse?.response?.data?.message || moveResponse?.message || "An error occurred while moving the audio";
                    errorToast(moveErrorMessage);
                }

                successToast(data.message);
                setOpenFolderCreateModal(false);
                setIsMoveToFolder(false)
                setLoad(false)

            } else {
                const errorMessage =
                    data?.response?.data?.message || data?.message || "An error occurred";
                console.log(errorMessage);
                errorToast(errorMessage);
                setLoad(false)

            }
        } catch (error) {
            console.log("Create Folder Error :", error);
            const errorMessage =
                error?.response?.data?.message || error?.message || "An error occurred";
            errorToast(errorMessage);
            setLoad(false)

        }
    };


    const handleClose = () => {
        setOpenFolderCreateModal(false);
        setFolderName("");
    };
    const handleReanmeModalClose = () => {
        setOpenRenameModal(false);
        setAudioReName("");
    };

    const handleMoveToFolderClose = () => {
        setOpenMoveToFolderModal(false)
        setSelectedFolderId('')

    }



    const dohandalMergeSelectAudio = (audio) => {

        const fileExtension = audio?.audio?.fileName.split('.').pop().toLowerCase();

        if (fileExtension === "caf" || fileExtension === "m4a") {
            // Show modal with a warning message
            setModalMessage("This audio format is not supported for the web platform.");
            setShowModal(true);
            setAudioIndex(0);
            setAudio("");
            return;
        }

        // Check if the audio object already exists in the selectMergeAudio array
        const alreadyExists = selectMergeAudio.some(
            (item) => item._id === audio._id
        );
        // Check if the selection limit is reached
        if (selectMergeAudio.length >= 5 && !selectMergeAudio.includes(audio)) {
            errorToastBottom("You can select up to 5 audios for merging.");
            return;
        }

        // If it doesn't exist, add it to the array
        if (!alreadyExists) {
            setSelectMergeAudio([...selectMergeAudio, audio]);
            setClickedAudios(new Set(clickedAudios).add(audio._id));
        }
    };

    const handleFilter = (e, type) => {
        e.preventDefault();
        let sortedData = [...filterAudioData];
        if (type === "date") {
            if (isDateAscending) {
                sortedData.sort(
                    (a, b) => new Date(a.createdAt) - new Date(b.createdAt)
                );
            } else {
                sortedData.sort(
                    (a, b) => new Date(b.createdAt) - new Date(a.createdAt)
                );
            }
            setIsDateAscending(!isDateAscending);
        } else if (type === "name") {
            if (isNameAscending) {
                sortedData.sort((a, b) =>
                    a.audio.fileName.localeCompare(b.audio.fileName)
                );
            } else {
                sortedData.sort((a, b) =>
                    b.audio.fileName.localeCompare(a.audio.fileName)
                );
            }
            setIsNameAscending(!isNameAscending);
        } else if (type === "size") {
            if (isSizeAscending) {
                sortedData.sort(
                    (a, b) => parseInt(a.audio.fileSize) - parseInt(b.audio.fileSize)
                );
            } else {
                sortedData.sort(
                    (a, b) => parseInt(b.audio.fileSize) - parseInt(a.audio.fileSize)
                );
            }
            setIsSizeAscending(!isSizeAscending);
        }
        setFilterAudioData(sortedData);

    };





    // handle Filter on Favourite Audio
    const handleFilterFavouriteAudio = (e, type) => {
        e.preventDefault();
        let sortedData = [...favoriteAudio];
        if (type === "date") {
            if (isDateAscending) {
                sortedData.sort(
                    (a, b) => new Date(a.createdAt) - new Date(b.createdAt)
                );
            } else {
                sortedData.sort(
                    (a, b) => new Date(b.createdAt) - new Date(a.createdAt)
                );
            }
            setIsDateAscending(!isDateAscending);
        } else if (type === "name") {
            if (isNameAscending) {
                sortedData.sort((a, b) =>
                    a.audio.fileName.localeCompare(b.audio.fileName)
                );
            } else {
                sortedData.sort((a, b) =>
                    b.audio.fileName.localeCompare(a.audio.fileName)
                );
            }
            setIsNameAscending(!isNameAscending);
        } else if (type === "size") {
            if (isSizeAscending) {
                sortedData.sort(
                    (a, b) => parseInt(a.audio.fileSize) - parseInt(b.audio.fileSize)
                );
            } else {
                sortedData.sort(
                    (a, b) => parseInt(b.audio.fileSize) - parseInt(a.audio.fileSize)
                );
            }
            setIsSizeAscending(!isSizeAscending);
        }
        setFavoriteAudio(sortedData);
    };


    const handleRenameAudioRecording = async (e) => {
        e.preventDefault();
        const reNameAudio = audioReName.trim();
        setLoad(true);

        try {
            const payload = {
                "fileName": reNameAudio,
            };
            const data = await AudioHandler.doUpdateRecording(
                currentAudioId,
                payload
            );

            if (data?.statusCode === 200) {
                // console.log(data, 'data')
                successToast("Rename Successfully");
                setAudioReName("");
                setOpenRenameModal(false);
                setLoad(false);

                // Update the filterAudioData state if the ID matches
                setFilterAudioData((prevFilterAudioData) =>
                    prevFilterAudioData.map((audioItem) => {
                        return audioItem._id === currentAudioId
                            ? {
                                ...audioItem,
                                audio: {
                                    ...audioItem?.audio,
                                    fileName: data?.data?.audio?.fileName,
                                    url: data?.data?.audio?.url
                                }
                            }
                            : audioItem
                    }
                    )
                );

                if (listTabIndex === 2) {
                    // Update the filterAudioData state if the ID matches
                    setFavoriteAudio((prevFilterAudioData) =>
                        prevFilterAudioData.map((audioItem) => {
                            return audioItem._id === currentAudioId
                                ? {
                                    ...audioItem,
                                    audio: {
                                        ...audioItem?.audio,
                                        fileName: data?.data?.audio?.fileName,
                                    }
                                }
                                : audioItem
                        }
                        )
                    );
                }

                // Update the audio state with the new data if the currentAudioId matches
                setAudio((prevAudio) => {
                    console.log(prevAudio)
                    if (prevAudio && prevAudio._id === currentAudioId) {
                        return {
                            ...data.data,
                        };
                    }
                    return prevAudio;
                });

            } else {
                const errorMessage =
                    data?.response?.data?.error || data?.response?.data?.message || data.message || "An error occurred";
                // console.log(errorMessage);
                errorToast(errorMessage);
                setLoad(false);

            }
        } catch (error) {
            const errorMessage =
                error?.response?.data?.message || error.message || "An error occurred";
            console.log(errorMessage);
            errorToast(errorMessage);
            setLoad(false);

        }
    };

    const handleMoveAudio = async (e) => {
        e.preventDefault();
        try {
            const payload = {
                audioId: currentAudioId,
                folderId: selectedFolderId
            }
            const response = await AudioHandler.doMoveToFolder(payload);
            // console.log(response, 'move response');
            if (response.statusCode === 200) {
                // successToast('Audio moved to new folder successfully');
                setFilterAudioData((prevAudios) =>
                    prevAudios.filter(audio => audio?._id !== currentAudioId)
                );
                setFavoriteAudio((prevAudios) =>
                    prevAudios.filter(audio => audio?._id !== currentAudioId)
                );

            } else {
                const errorMessage =
                    response?.data?.message || response?.message || "An error occurred";
                errorToast(errorMessage);
            }
            setOpenMoveToFolderModal(false);
            setIsMoveToFolder(false)
            setSelectedFolderId('')

            // Refresh audio list or update state here if necessary
        } catch (error) {
            console.error('Error moving audio:', error);
            const errorMessage =
                error?.response?.data?.message || error.message || error?.response?.message || "An error occurred";
            console.log(errorMessage);
            errorToast(errorMessage);
        }
    };


    useEffect(() => {
        const isValidAudioReName = typeof audioReName === 'string' && audioReName.length >= 3;

        // Disable the button if audioReName is empty or if it hasn't changed from the initial value
        setIsButtonDisabled(audioReName === "" || !isValidAudioReName || audioReName === initialAudioName || !(audioReName.trim().length >= 3));
    }, [audioReName]);


    useEffect(() => {
        if (folders?.length === 0 && noFolderAudioData?.length === 0) {
            // console.log("No folders and no audios available");
            // console.log(folders.length, noFolderAudioData.length)

        }
    }, [folders, noFolderAudioData]);



    const handleToggleCollapse = (id) => {
        setCollapsedIds((prevIds) => {
            const newSet = new Set(prevIds);
            if (newSet.has(id)) {
                newSet.delete(id);
            } else {
                newSet.clear(); // Clear all previous IDs to ensure only one is expanded
                newSet.add(id);
            }
            return newSet;
        });
    };

    const handleGetFolderRecording = async (id) => {
        try {
            setLoad(true);
            const data = await AudioHandler.doGetFolderRecording(id);
            // console.log(data, 'folder recording');
            if (data?.statusCode === 200) {
                setFolderAudioData(data?.data?.audio);
                setLoad(false);
            }
        } catch (error) {
            console.error("error to fetch data", error);
        }
    };

    const handleFolderClick = async (id, event) => {
        event.stopPropagation(); // Prevents event from bubbling up
        if (collapsedIds.has(id)) {
            handleToggleCollapse(id); // Collapse if already expanded
        } else {
            await handleGetFolderRecording(id); // Fetch data before expanding
            handleToggleCollapse(id);
        }
    };



    const toggleDropdown = (folderId) => {
        // setIsOpen(!isOpen);
        setIsOpen(prevState => (prevState === folderId ? false : folderId));

    };

    const closeDropdown = () => {
        setIsOpen(false);
    };


    const handleClickOutside = (event) => {
        if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
            closeDropdown();
        }
    };

    useEffect(() => {
        document.addEventListener('click', handleClickOutside);
        return () => {
            document.removeEventListener('click', handleClickOutside);
        };
    }, []);


    const handleRenameFolders = async (e, id) => {
        e.preventDefault();
        const payload = {
            name: folderReName
        }
        setLoading(true)
        try {
            const data = await doRenameFolder(id, payload);
            // console.log(data);
            if (data?.statusCode === 200) {
                setFolders((prevFolders) =>
                    prevFolders.map((folder) =>
                        folder._id === id ? { ...folder, name: folderReName } : folder
                    )
                );
                setFolderReName('');
                setOpenRenameFolder(false);
                setOpenRenameFolderId(null); // Close the rename modal
                setLoading(false)
                setSelectedFolderAudioId(data?.data)

            }
            else {
                const errorMessage =
                    data?.response?.data?.error || data?.response?.data?.message || data?.message || "An error occurred";
                console.log(errorMessage);
                errorToast(errorMessage);
                setLoading(false)


            }
        } catch (error) {
            console.error("error in Rename Folder", error);
            setLoading(false)

        }
    };

    const handleDeleteFolders = async (e, id) => {
        // console.log(id, 'iddddd')

        try {
            const data = await doDeleteFolder(id)
            if (data?.statusCode === 200) {
                // setFolders(prevFolders => prevFolders.filter(folder => folder?._id !== id));

                setFolders(prevFolders => {
                    const updatedFolders = prevFolders.filter(folder => folder?._id !== id);

                    // If folders length is zero, ensure noFolderAudioData is also checked
                    if (updatedFolders?.length === 0 && filterAudioData?.length === 0) {
                        // console.log('No folders')
                        setFolders([]);
                        setFilterAudioData([]);
                    }
                    return updatedFolders;
                });
                setDeleteFolderModal(false)
                setTabIndex(1)

            }
        } catch (error) {
            console.error("error on Delete Folder", error);

        }
    }


    useEffect(() => {
        const isValidFolderReName = typeof folderReName === 'string' && folderReName.length >= 3;

        // Disable the button if audioReName is empty or if it hasn't changed from the initial value
        setIsButtonDisabled(folderReName === "" || !isValidFolderReName || folderReName === initialFolderName || !(folderReName.trim().length >= 3));
    }, [folderReName]);

    const getFavouritesAudio = (e) => {

        e.stopPropagation()
        // Filter the favorite audio items
        const favoriteAudioResponse = filterAudioData?.filter(
            (item) => item?.isFavourite === true
        );
        setAudioIndex(0);
        setAudio("");

        // Update favoriteAudio state
        setFavoriteAudio(favoriteAudioResponse);


    };

    const toggleFilterDropdown = (e) => {
        e.stopPropagation();
        setIsFilterDropdownOpen((prev) => !prev)
        setIsOpen(false)
        setOpenDropdownId(null)
    };

    // Handle click outside the dropdown to close it
    const handleClickOutside1 = (event) => {
        if (dropdownFilterRef.current && !dropdownFilterRef.current.contains(event.target)) {
            setIsFilterDropdownOpen(false);
        }
    };

    // Effect to handle clicks outside the dropdown
    useEffect(() => {
        document.addEventListener('mousedown', handleClickOutside1);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside1);
        };
    }, []);

    useEffect(() => {
        if (filterAudioData?.length === 0) {
            setIsRecordingStarted(false);
        }
    }, [filterAudioData]);

    // Each folder or screen starts unfiltered.
    useEffect(() => {
        setActionFilter(ALL_ACTIONS_FILTER);
    }, [tabIndex]);

    const actionSourceList = (listTabIndex === 1 ? filterAudioData : favoriteAudio) || [];
    const actionCounts = Object.fromEntries(
        AUDIO_ACTION_FILTERS.map((item) => [item.id, actionSourceList.filter(item.matches).length])
    );
    const activeActionFilter = AUDIO_ACTION_FILTERS.find((item) => item.id === actionFilter) || AUDIO_ACTION_FILTERS[0];
    const isActionFilterEmpty = actionFilter !== ALL_ACTIONS_FILTER && !actionCounts[actionFilter];
    const hasActionFilterRow = actionSourceList.length > 0;
    // Scroll arrows only show once every action filter has recordings.
    const hasAllActionFilters = AUDIO_ACTION_FILTERS.every((item) => actionCounts[item.id] > 0);

    const updateActionFilterOverflow = () => {
        const row = actionFilterRowRef.current;
        if (!row) return;
        const start = row.scrollLeft > 1;
        const end = row.scrollLeft + row.clientWidth < row.scrollWidth - 1;
        setActionFilterOverflow((prev) => (prev.start === start && prev.end === end ? prev : { start, end }));
    };

    // Re-measure when the row appears or the list column is resized.
    useEffect(() => {
        const row = actionFilterRowRef.current;
        if (!row) return undefined;
        updateActionFilterOverflow();
        if (typeof ResizeObserver === "undefined") return undefined;
        const observer = new ResizeObserver(updateActionFilterOverflow);
        observer.observe(row);
        return () => observer.disconnect();
    }, [hasActionFilterRow, hasAllActionFilters]);

    // Keeps the selected chip in view.
    useEffect(() => {
        const active = actionFilterRowRef.current?.querySelector(".vr-rl-actchip.is-active");
        active?.scrollIntoView?.({ block: "nearest", inline: "nearest", behavior: "smooth" });
    }, [actionFilter, hasActionFilterRow]);

    const scrollActionFilter = (direction) => {
        const row = actionFilterRowRef.current;
        if (!row) return;
        row.scrollBy({ left: direction * Math.max(120, row.clientWidth * 0.7), behavior: "smooth" });
    };

    // A plain mouse wheel scrolls the chip row sideways.
    const handleActionFilterWheel = (e) => {
        const row = actionFilterRowRef.current;
        if (!row || Math.abs(e.deltaX) > Math.abs(e.deltaY)) return;
        row.scrollLeft += e.deltaY;
    };

    const actionFilterEmpty = (
        <div className="vr-rl-empty">
            <div className="vr-rl-empty-icon">
                <Icon icon={activeActionFilter.icon} width="26" height="26" />
            </div>
            <p className="vr-rl-empty-title">
                No {activeActionFilter.label} Recordings
            </p>
            <p className="vr-rl-empty-sub">
                None of the recordings here match this filter.
            </p>
            <button type="button" className="vr-rl-actfilter-reset" onClick={() => setActionFilter(ALL_ACTIONS_FILTER)}>
                Show all recordings
            </button>
        </div>
    );

    return (
        <div className="vr-rl">
            <div className="vr-rl-head">
                <h4 className="vr-rl-title mb-0">
                    <span>

                        {(tabIndex == selectedFolderAudioId?._id) ? selectedFolderAudioId?.name : "My Recordings"}
                    </span>
                </h4>
                <div className="vr-rl-actions">
                    <div className={`dropdown`} ref={dropdownFilterRef} style={{ position: 'relative' }}>
                        <button
                            type="button"
                            aria-label="more-icons"
                            aria-expanded={!!isFilterDropdownOpen}
                            className={`vr-iconbtn vr-rl-iconbtn${isFilterDropdownOpen ? " is-open" : ""}`}
                            // className="dropdown-toggle"
                            // data-bs-toggle="dropdown"
                            onClick={(e) => toggleFilterDropdown(e)}

                        >
                            <Icon icon="lucide:list-filter" width="18" height="18" />
                        </button>
                        {isFilterDropdownOpen && (
                            <>
                                <ul
                                    className="dropdown-menu vr-rl-menu vr-rl-sortmenu"
                                    onClick={() => setIsFilterDropdownOpen(false)}
                                >
                                    <li
                                        className="vr-rl-menu-item"
                                        onClick={(e) => {
                                            if (listTabIndex === 1) {
                                                handleFilter(e, "date");
                                            } else if (listTabIndex === 2) {
                                                handleFilterFavouriteAudio(e, "date");
                                            }
                                            setIsFilterDropdownOpen(false);

                                        }
                                        }
                                    >
                                        <Icon icon="lucide:calendar" className="vr-rl-menu-icon" aria-label="date" />
                                        <span
                                            className="vr-rl-menu-label"
                                            href=""
                                        >
                                            Date
                                        </span>
                                    </li>
                                    <li
                                        className="vr-rl-menu-item"
                                        onClick={(e) => {
                                            if (listTabIndex === 1) {
                                                handleFilter(e, "name");
                                            } else if (listTabIndex === 2) {
                                                handleFilterFavouriteAudio(e, "name");
                                            }
                                            setIsFilterDropdownOpen(false);

                                        }}
                                    >
                                        <Icon icon="lucide:arrow-down-a-z" className="vr-rl-menu-icon" aria-label="name" />
                                        <span
                                            className="vr-rl-menu-label"
                                            href=""
                                        >
                                            Name
                                        </span>
                                    </li>
                                    <li
                                        className="vr-rl-menu-item"
                                        onClick={(e) => {
                                            {
                                                if (listTabIndex === 1) {
                                                    handleFilter(e, "size");
                                                } else if (listTabIndex === 2) {
                                                    handleFilterFavouriteAudio(e, "size");
                                                }
                                            }
                                            setIsFilterDropdownOpen(false);

                                        }}
                                    >
                                        <Icon icon="lucide:hard-drive" className="vr-rl-menu-icon" aria-label="size" />
                                        <span
                                            className="vr-rl-menu-label"
                                            href=""
                                        >
                                            Size
                                        </span>
                                    </li>
                                </ul>
                            </>
                        )}

                    </div>
                    <div className="dropdown" style={{ position: 'relative' }} ref={dropdownRef} >
                        {tabIndex != 2 && (
                            <>
                                <button
                                    type="button"
                                    aria-label="Folder options"
                                    className="dropdown-toggle vr-iconbtn vr-rl-iconbtn"
                                    onClick={async (e) => {
                                        e.stopPropagation(); // Prevent folder toggle on dropdown click
                                        toggleDropdown(selectedFolderAudioId?._id);
                                        setOpenDropdownId(selectedFolderAudioId?._id); // Open dropdown for the clicked item
                                        setIsFilterDropdownOpen(false);
                                    }}

                                >
                                    <Icon icon="lucide:more-horizontal" width="18" height="18" />
                                </button>
                                {openDropdownId === selectedFolderAudioId?._id && isOpen === selectedFolderAudioId?._id && (
                                    <ul
                                        className="vr-rl-menu vr-rl-foldermenu"
                                        onClick={(e) => e.stopPropagation()}
                                    >
                                        <li
                                            className="vr-rl-menu-item"
                                            onClick={(e) => {
                                                e.stopPropagation();
                                                e.preventDefault();
                                                setOpenRenameFolderId(selectedFolderAudioId?._id); // Set the folder ID for the rename modal
                                                setInitialFolderName(selectedFolderAudioId?.name);
                                                setFolderReName(selectedFolderAudioId?.name);
                                                closeDropdown();
                                            }}
                                        >
                                            <Icon icon="lucide:pencil" className="vr-rl-menu-icon" />
                                            <a
                                                className="vr-rl-menu-label"
                                                href=""
                                            >
                                                Rename
                                            </a>
                                        </li>
                                        <li
                                            className="vr-rl-menu-item is-danger"
                                            onClick={async (e) => {
                                                e.preventDefault(); // Prevent the default behavior (e.g., page refresh)
                                                closeDropdown();
                                                if (selectedFolderAudioId?._id) {
                                                    setDeleteDataId(selectedFolderAudioId._id); // Set the _id if it exists
                                                }
                                                var FolderAudiodataLength = await AudioHandler.doGetFolderRecording(selectedFolderAudioId?._id);

                                                if (FolderAudiodataLength?.data?.audio?.length === 0) {
                                                    handleDeleteFolders(e, selectedFolderAudioId?._id); // Proceed to delete the folder
                                                }
                                                else {
                                                    setDeleteFolderModal(true); // Show delete confirmation modal
                                                }
                                            }}
                                        >
                                            <Icon icon="lucide:trash-2" className="vr-rl-menu-icon" />
                                            <a
                                                className="vr-rl-menu-label"
                                                href=""
                                            >
                                                Delete
                                            </a>
                                        </li>
                                    </ul>
                                )}
                            </>
                        )}
                    </div>
                </div>
            </div>
            <div className="vr-rl-segwrap">
                <div className={`vr-rl-seg${listTabIndex === 2 ? " is-second" : ""}`} role="tablist">
                    <span className="vr-rl-seg-thumb" aria-hidden="true" />
                    <button
                        onClick={() => {
                            setListTabIndex(1);
                            setAudioIndex(0);
                            setAudio("");
                        }
                        }
                        role="tab"
                        aria-selected={listTabIndex === 1}
                        className={`vr-rl-seg-btn${listTabIndex === 1 ? " is-active" : ""}`}
                    >
                        All
                    </button>
                    <button
                        onClick={(e) => {
                            setListTabIndex(2);
                            getFavouritesAudio(e)
                        }}
                        role="tab"
                        aria-selected={listTabIndex === 2}
                        className={`vr-rl-seg-btn${listTabIndex === 2 ? " is-active" : ""}`}
                    >
                        Favorite
                    </button>
                </div>
                {hasActionFilterRow && (
                    <div
                        className={`vr-rl-actfilter-wrap${hasAllActionFilters && actionFilterOverflow.start ? " has-start" : ""}${hasAllActionFilters && actionFilterOverflow.end ? " has-end" : ""}`}
                    >
                        <button
                            type="button"
                            className="vr-rl-actfilter-arrow is-start"
                            aria-label="Show previous filters"
                            tabIndex={-1}
                            onClick={() => scrollActionFilter(-1)}
                        >
                            <Icon icon="lucide:chevron-left" width="16" height="16" />
                        </button>
                        <div
                            className="vr-rl-actfilter"
                            role="toolbar"
                            aria-label="Filter recordings by action"
                            ref={actionFilterRowRef}
                            onScroll={updateActionFilterOverflow}
                            onWheel={handleActionFilterWheel}
                        >
                            {AUDIO_ACTION_FILTERS.map((item) => {
                                const isActive = actionFilter === item.id;
                                const count = actionCounts[item.id] || 0;
                                // Empty filters are hidden, unless it is the selected one.
                                if (!count && !isActive) return null;
                                return (
                                    <button
                                        type="button"
                                        key={item.id}
                                        aria-pressed={isActive}
                                        title={`Show ${item.label === "All" ? "all" : item.label} recordings`}
                                        className={`vr-rl-actchip${isActive ? " is-active" : ""}`}
                                        onClick={() => setActionFilter(item.id)}
                                    >
                                        <Icon icon={item.icon} className="vr-rl-actchip-icon" aria-hidden="true" />
                                        <span>{item.label}</span>
                                        <span className="vr-rl-actchip-count">{count}</span>
                                    </button>
                                );
                            })}
                        </div>
                        <button
                            type="button"
                            className="vr-rl-actfilter-arrow is-end"
                            aria-label="Show more filters"
                            tabIndex={-1}
                            onClick={() => scrollActionFilter(1)}
                        >
                            <Icon icon="lucide:chevron-right" width="16" height="16" />
                        </button>
                    </div>
                )}
            </div>

            {
                load ? (
                    <div className="vr-rl-loading">
                        <div
                            className="vr-spinner vr-rl-spinner"
                            role="status"
                        >
                            <span className="visually-hidden">Loading...</span>
                        </div>
                    </div>
                ) : listTabIndex === 1 ? (
                    <div className="vr-rl-scroll scroll">
                        <div>
                            <>
                                <div>
                                    {filterAudioData?.length === 0 ? (
                                        <div className="vr-rl-empty">
                                            <div className={`vr-rl-empty-icon${isRecordingStarted ? " is-live" : ""}`}>
                                                <Icon icon={isRecordingStarted ? "lucide:mic" : "lucide:audio-lines"} width="26" height="26" />
                                            </div>
                                            <p className="vr-rl-empty-title">
                                                No Recordings
                                            </p>
                                            <p className="vr-rl-empty-sub">
                                                {!isRecordingStarted ? 'Please click on "Start Recording" button down here to record your first audio.' : 'Recording in progress Speak freely! Tap the "Stop" Recording button once you are done.'}
                                            </p>
                                            {!isRecordingStarted && (
                                                <div className="vr-rl-empty-cta" >
                                                    <PlayButton
                                                        click={() => { setAutoStartRecording(true); setRecordingFolderId(tabIndex != "1" && tabIndex != "2" && tabIndex != "3" ? tabIndex : null); setTabIndex(1); setAudio(); setActionTabIndex(null); setRecordNew(false); }}
                                                        src={"/img/button/music.png"}
                                                        btnText={"Start Recording"}
                                                        MainStartRecording
                                                        altName='Play Button'
                                                    />
                                                </div>
                                            )}

                                        </div>
                                    ) : isActionFilterEmpty ? (
                                        actionFilterEmpty
                                    ) : (
                                        <>
                                            <AudioFile
                                                actionFilter={actionFilter}
                                                dohandalMergeSelectAudio={dohandalMergeSelectAudio}
                                                clickedAudios={clickedAudios}
                                                setOpenRenameModal={setOpenRenameModal}
                                                setOpenMoveToFolderModal={setOpenMoveToFolderModal}
                                                setIsMoveToFolder={setIsMoveToFolder}
                                                isMoveToFolder={isMoveToFolder}
                                                folders={folders}
                                                setFolders={setFolders}
                                            />


                                        </>
                                    )}

                                </div>

                            </>
                        </div>
                    </div>
                ) : (
                    <div className="vr-rl-scroll scroll">
                        {(favoriteAudio?.length === 0) ? (
                            <div className="vr-rl-empty">
                                <div className="vr-rl-empty-icon">
                                    <Icon icon="lucide:heart" width="26" height="26" />
                                </div>
                                <p className="vr-rl-empty-title">
                                    No Favorite Recordings
                                </p>
                                <p className="vr-rl-empty-sub">
                                    Make your favorite recordings to easily access them.
                                </p>
                            </div>
                        ) : isActionFilterEmpty ? (
                            actionFilterEmpty
                        ) : (
                            <>
                                <AudioFile
                                    actionFilter={actionFilter}
                                    listTabIndex={listTabIndex}
                                    setOpenRenameModal={setOpenRenameModal}
                                    dohandalMergeSelectAudio={dohandalMergeSelectAudio}
                                    setOpenMoveToFolderModal={setOpenMoveToFolderModal}
                                    setIsMoveToFolder={setIsMoveToFolder}
                                    isMoveToFolder={isMoveToFolder}
                                />
                            </>
                        )}

                    </div>
                )
            }

            {
                openRenameModal && (
                    <Modal
                        onClose={(e) => handleReanmeModalClose(e)}
                        modaltxt={"Rename Recording"}
                        closeButtonDisabled={load}
                    >
                        <div className="vr-rl-form">
                            <div className="form-group vr-rl-field">
                                <input
                                    type="text"
                                    className="vr-input vr-rl-input"
                                    id="recordingname"
                                    name="recordingname"
                                    placeholder="Recording Name"
                                    value={audioReName}
                                    onChange={(e) => {
                                        const inputValue = e.target.value;
                                        if (inputValue.length <= maxLengthAudioRename) {
                                            setAudioReName(inputValue);
                                        }
                                    }}
                                />
                                <div className="vr-rl-count">
                                    {`${audioReName?.length}/${maxLengthAudioRename}`}
                                </div>
                            </div>
                            <div className="form-group">
                                <button
                                    type="submit"
                                    disabled={isButtonDisabled}
                                    className="vr-btn vr-btn-primary vr-btn-lg vr-btn-block"
                                    onClick={(e) => handleRenameAudioRecording(e)}
                                >

                                    {load ? (
                                        <>
                                            <span>Saving</span>
                                            <div
                                                className="vr-spinner vr-rl-btn-spinner"
                                                role="status"
                                            >
                                                <span className="visually-hidden">Loading...</span>
                                            </div>
                                        </>
                                    ) : (
                                        <>
                                            <span>
                                                Save
                                            </span>
                                        </>
                                    )
                                    }
                                </button>
                            </div>
                        </div>
                    </Modal>
                )
            }

            {
                openMoveToFolderModal && (
                    <Modal onClose={(e) => handleMoveToFolderClose(e)} modaltxt={"Move Audio to Folder"}>
                        <div className="vr-rl-form">
                            <div className="form-group vr-rl-field vr-rl-selectwrap">
                                <Icon icon="lucide:folder" className="vr-rl-select-icon" aria-hidden="true" />
                                <select
                                    id="folderSelect"
                                    className="form-select vr-rl-select"
                                    value={selectedFolderId}
                                    onChange={(e) => setSelectedFolderId(e.target.value)}
                                >
                                    <option value="" disabled>{folders.length === 0 ? "No Folder To Select" : "Select a folder"}</option>
                                    {folders.filter((el) => !el.isDeleted).map(folder => (
                                        <option key={folder._id} value={folder._id}>
                                            {folder.name}
                                        </option>
                                    ))}
                                </select>
                            </div>
                            <div className="form-group">
                                <button
                                    type="submit"
                                    disabled={!selectedFolderId}
                                    className="vr-btn vr-btn-primary vr-btn-lg vr-btn-block"
                                    onClick={(e) => { handleMoveAudio(e) }}
                                >
                                    Move
                                </button>
                            </div>
                            <div className="form-group vr-rl-or">

                                <span>OR</span>

                            </div>
                            <div className="form-group">
                                <button
                                    type="submit"
                                    className="vr-btn vr-btn-secondary vr-btn-lg vr-btn-block"
                                    onClick={() => { setOpenFolderCreateModal(true); setOpenMoveToFolderModal(false); setSelectedFolderId('') }}
                                >
                                    <Icon icon="lucide:folder-plus" width="18" height="18" />
                                    Create New Folder and Move
                                </button>
                            </div>
                        </div>
                    </Modal>
                )
            }

            {
                deleteFolderModal && (
                    <Modal
                        onClose={(e) => {
                            setDeleteFolderModal(false);
                        }}
                        modaltxt={"Voice Recorder"}
                    >
                        <div className="vr-rl-form" onClick={(e) => e.stopPropagation()}>
                            <div className="form-group vr-rl-confirm">
                                <span className="vr-rl-confirm-icon"><Icon icon="lucide:trash-2" width="20" height="20" /></span>
                                <p>Are you sure want to delete this Folder? </p>
                            </div>
                            <div className="form-group vr-rl-btnrow">
                                <button
                                    type="submit"
                                    className="vr-btn vr-btn-secondary vr-btn-lg vr-btn-block"
                                    onClick={(e) =>
                                        setDeleteFolderModal(false)
                                    }
                                >

                                    {loading ? (
                                        <>
                                            <span>Saving</span>
                                            <div
                                                className="vr-spinner vr-rl-btn-spinner"
                                                role="status"
                                            >
                                                <span className="visually-hidden">Loading...</span>
                                            </div>
                                        </>
                                    ) : (
                                        <>
                                            <span>
                                                Cancel
                                            </span>
                                        </>
                                    )
                                    }
                                </button>

                                <button
                                    type="submit"
                                    className="vr-btn vr-btn-accent vr-btn-lg vr-btn-block"
                                    onClick={(e) => {
                                        if (deleteDataId) {
                                            handleDeleteFolders(e, deleteDataId); // Use deleteDataId from state
                                        }
                                    }
                                    }
                                >

                                    {loading ? (
                                        <>
                                            <span>Saving</span>
                                            <div
                                                className="vr-spinner vr-rl-btn-spinner"
                                                role="status"
                                            >
                                                <span className="visually-hidden">Loading...</span>
                                            </div>
                                        </>
                                    ) : (
                                        <>
                                            <span>
                                                Remove
                                            </span>
                                        </>
                                    )
                                    }
                                </button>
                            </div>
                        </div>
                    </Modal>
                )
            }

            {
                openRenameFolderId === selectedFolderAudioId?._id && (
                    <Modal
                        // onClose={() => setOpenRenameFolder(false)}
                        // onClose={() => setOpenRenameFolder(null)}
                        onClose={(e) => {
                            setOpenRenameFolderId(null);
                        }}
                        modaltxt={"Rename Folder"}
                        closeButtonDisabled={loading}

                    >
                        <div className="vr-rl-form" onClick={(e) => e.stopPropagation()}>
                            <div className="form-group vr-rl-field">
                                <input
                                    type="text"
                                    className="vr-input vr-rl-input"
                                    id="foldername"
                                    name="foldername"
                                    placeholder="Folder Name"
                                    value={folderReName}
                                    // onChange={(e) => setFolderReName(e.target.value)}
                                    onChange={(e) => {
                                        const inputValue = e?.target?.value;
                                        if (inputValue?.length <= maxLength) {
                                            setFolderReName(inputValue);
                                        }
                                    }
                                    }
                                />
                                <div className="vr-rl-count">
                                    {`${folderReName?.length}/${maxLength}`}
                                </div>
                            </div>
                            <div className="form-group">
                                <button
                                    type="submit"
                                    disabled={isButtonDisabled}
                                    className="vr-btn vr-btn-primary vr-btn-lg vr-btn-block"
                                    onClick={(e) =>
                                        handleRenameFolders(e, selectedFolderAudioId?._id)
                                    }
                                >

                                    {loading ? (
                                        <>
                                            <span>Saving</span>
                                            <div
                                                className="vr-spinner vr-rl-btn-spinner"
                                                role="status"
                                            >
                                                <span className="visually-hidden">Loading...</span>
                                            </div>
                                        </>
                                    ) : (
                                        <>
                                            <span>
                                                Save
                                            </span>
                                        </>
                                    )
                                    }
                                </button>
                            </div>
                        </div>
                    </Modal>
                )
            }

            {openFolderCreateModal && (
                <Modal
                    onClose={() => {
                        if (!load) {
                            handleClose()
                        }
                    }}
                    // onClose={() => handleClose()}
                    modaltxt={"Create New Folder"}
                    closeButtonDisabled={load}
                >
                    <div className="vr-rl-form">
                        <div className="form-group vr-rl-field vr-rl-selectwrap">
                            <Icon icon="lucide:folder-plus" className="vr-rl-select-icon" aria-hidden="true" />
                            <input
                                autoFocus
                                type="text"
                                className="vr-input vr-rl-input has-icon"
                                id="foldername"
                                name="foldername"
                                placeholder="Enter Folder Name"
                                value={folderName}
                                // onChange={(e) => { setFolderName(e.target.value) }}
                                onChange={(e) => {
                                    const inputValue = e?.target?.value;
                                    // Limit the length of the input value
                                    if (inputValue?.length <= maxLength) {
                                        setFolderName(inputValue);
                                    }
                                }}

                            />
                            <div className="vr-rl-count">
                                {`${folderName?.length}/${maxLength}`}
                            </div>
                        </div>
                        <div className="form-group">


                            {isMoveToFolder ? (<button
                                type="submit"

                                // disabled={!folderName}
                                disabled={!(folderName.trim().length >= 3)}
                                onClick={() => {
                                    handleSaveAndMove()
                                }}
                                className="vr-btn vr-btn-primary vr-btn-lg vr-btn-block"
                            >

                                {load ? (
                                    <>
                                        <span>Create And Move</span>
                                        <div
                                            className="vr-spinner vr-rl-btn-spinner"
                                            role="status"
                                        >
                                            <span className="visually-hidden">Loading...</span>
                                        </div>
                                    </>
                                ) : (
                                    <>
                                        <span>
                                            Create and Move
                                        </span>
                                    </>
                                )
                                }

                            </button>) : (<button
                                type="submit"
                                // disabled={!folderName}
                                // disabled={!(folderName && folderName.length >= 3)}
                                disabled={!(folderName.trim().length >= 3)}
                                onClick={() => handleSave()}
                                className="vr-btn vr-btn-primary vr-btn-lg vr-btn-block"
                            >

                                {load ? (
                                    <>
                                        <span>Creating</span>
                                        <div
                                            className="vr-spinner vr-rl-btn-spinner"
                                            role="status"
                                        >
                                            <span className="visually-hidden">Loading...</span>
                                        </div>
                                    </>
                                ) : (
                                    <>
                                        <span>
                                            Create
                                        </span>
                                    </>
                                )
                                }
                            </button>)}
                        </div>
                    </div>
                </Modal>
            )}

        </div >
    );
};

export default AudioList;
